export default __webpack_public_path__ + "static/media/Brand of Ashur.7873e29e.jpg";